import { Packet } from '@escrowtab/packets-api-client';
import { ProfileDto } from '@escrowtab/v2profile-api-client';
import {
  AuditAction,
  EtJournalEntry,
  EtjournalPacketEntry,
  EtJournalSigner,
} from '@et/typings';

export enum EjournalSessionActionsType {
  SET_PROFILE = '[EJOURNAL_SESSION] set profile',
  SET_SELECTED_PACKET = '[EJOURNAL_SESSION] set selected packet',
  SET_EJOURNAL = '[EJOURNAL_SESSION] set eJournal',
  SET_SIGNERS = '[EJOURNAL_SESSION] set signers',
  SET_ENTRIES = '[EJOURNAL_SESSION] set entries',
  SET_NOTARIZED_AUDIT_ACTIONS = '[EJOURNAL_SESSION] set notarized audit actions',
  SET_NOTARIZED_AUDIT_LOADED = '[EJOURNAL_SESSION] set notarized audit loaded',
  SET_PAGE_NAMES_BY_NUMBER = '[EJOURNAL_SESSION] set page names by number',
  UPDATE_SIGNERS = '[EJOURNAL_SESSION] update signers',
  UPDATE_ENTRIES = '[EJOURNAL_SESSION] update entries',
  SET_EJOURNAL_LOADING = '[EJOURNAL_SESSION] set eJournal loading',
  SET_SIGNERS_LOADING = '[EJOURNAL_SESSION] set signers loading',
  SET_ENTRIES_LOADING = '[EJOURNAL_SESSION] set entries loading',
  SET_EJOURNAL_ERROR = '[EJOURNAL_SESSION] set eJournal error',
  SET_SIGNERS_ERROR = '[EJOURNAL_SESSION] set signers error',
  SET_ENTRIES_ERROR = '[EJOURNAL_SESSION] set entries error',
  SET_IP = '[EJOURNAL_SESSION] set ip',
  SET_JOURNAL_PAYLOAD = '[EJOURNAL_SESSION] set journal payload',
  RESET_EJOURNAL_SESSION = '[EJOURNAL_SESSION] reset session',
  CLEAR_EJOURNAL_SESSION = '[EJOURNAL_SESSION] clear session',
}

export class SetProfile {
  static readonly type = EjournalSessionActionsType.SET_PROFILE;
  constructor(public profile: ProfileDto | undefined) {}
}

export class SetSelectedPacket {
  static readonly type = EjournalSessionActionsType.SET_SELECTED_PACKET;
  constructor(public selectedPacket: Packet | null) {}
}

export class SetEjournal {
  static readonly type = EjournalSessionActionsType.SET_EJOURNAL;
  constructor(public eJournal: EtjournalPacketEntry | null) {}
}

export class SetSigners {
  static readonly type = EjournalSessionActionsType.SET_SIGNERS;
  constructor(public signers: EtJournalSigner[]) {}
}

export class SetEntries {
  static readonly type = EjournalSessionActionsType.SET_ENTRIES;
  constructor(public entries: EtJournalEntry[]) {}
}

export class SetNotarizedAuditActions {
  static readonly type = EjournalSessionActionsType.SET_NOTARIZED_AUDIT_ACTIONS;
  constructor(public notarizedAuditActions: AuditAction[]) {}
}

export class SetNotarizedAuditLoaded {
  static readonly type = EjournalSessionActionsType.SET_NOTARIZED_AUDIT_LOADED;
  constructor(public notarizedAuditLoaded: boolean) {}
}

export class SetPageNamesByNumber {
  static readonly type = EjournalSessionActionsType.SET_PAGE_NAMES_BY_NUMBER;
  constructor(public pageNamesByNumber: Record<number, string>) {}
}

export class UpdateSigners {
  static readonly type = EjournalSessionActionsType.UPDATE_SIGNERS;
  constructor(
    public updater: (signers: EtJournalSigner[]) => EtJournalSigner[],
  ) {}
}

export class UpdateEntries {
  static readonly type = EjournalSessionActionsType.UPDATE_ENTRIES;
  constructor(
    public updater: (entries: EtJournalEntry[]) => EtJournalEntry[],
  ) {}
}

export class SetEjournalLoading {
  static readonly type = EjournalSessionActionsType.SET_EJOURNAL_LOADING;
  constructor(public eJournalLoading: boolean) {}
}

export class SetSignersLoading {
  static readonly type = EjournalSessionActionsType.SET_SIGNERS_LOADING;
  constructor(public signersLoading: boolean) {}
}

export class SetEntriesLoading {
  static readonly type = EjournalSessionActionsType.SET_ENTRIES_LOADING;
  constructor(public entriesLoading: boolean) {}
}

export class SetEjournalError {
  static readonly type = EjournalSessionActionsType.SET_EJOURNAL_ERROR;
  constructor(public eJournalError: string | null) {}
}

export class SetSignersError {
  static readonly type = EjournalSessionActionsType.SET_SIGNERS_ERROR;
  constructor(public signersError: string | null) {}
}

export class SetEntriesError {
  static readonly type = EjournalSessionActionsType.SET_ENTRIES_ERROR;
  constructor(public entriesError: string | null) {}
}

export class SetIp {
  static readonly type = EjournalSessionActionsType.SET_IP;
  constructor(public ip: string | null) {}
}

export class SetJournalPayload {
  static readonly type = EjournalSessionActionsType.SET_JOURNAL_PAYLOAD;
  constructor(
    public eJournal: EtjournalPacketEntry,
    public signers: EtJournalSigner[],
    public entries: EtJournalEntry[],
  ) {}
}

export class ResetEjournalSession {
  static readonly type = EjournalSessionActionsType.RESET_EJOURNAL_SESSION;
}

export class ClearEjournalSession {
  static readonly type = EjournalSessionActionsType.CLEAR_EJOURNAL_SESSION;
}
